var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-dialog",
        {
          attrs: {
            title: "指定发货",
            visible: _vm.dialogVisible,
            width: "1200px",
            "before-close": _vm.handleClose,
          },
          on: {
            "update:visible": function ($event) {
              _vm.dialogVisible = $event
            },
          },
        },
        [
          _c(
            "div",
            { staticClass: "flex flex-spacebetween align-items mb16" },
            [
              _c("div", [_vm._v("寻源商品总数：" + _vm._s(_vm.skuNum))]),
              _c(
                "div",
                [
                  _c(
                    "el-button",
                    { attrs: { type: "primary" }, on: { click: _vm.onAdd } },
                    [_vm._v("添加包裹")]
                  ),
                ],
                1
              ),
            ]
          ),
          _c(
            "el-table",
            {
              staticStyle: { width: "100%" },
              attrs: {
                data: _vm.data,
                border: "",
                stripe: "",
                "empty-text": "请先添加包裹",
              },
            },
            [
              _c("el-table-column", {
                attrs: {
                  type: "index",
                  prop: "sn",
                  label: "包裹序号",
                  align: "center",
                  width: "100",
                },
              }),
              _c("el-table-column", {
                attrs: { prop: "", label: "包裹商品", align: "center" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c(
                          "el-button",
                          {
                            attrs: { type: "text" },
                            on: {
                              click: function ($event) {
                                return _vm.onLook(scope.row)
                              },
                            },
                          },
                          [_vm._v(_vm._s(_vm.$t("viewText")))]
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "goodsNum",
                  label: "包裹商品数",
                  align: "center",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "stockWarehouseCode",
                  label: "发货仓库编码",
                  align: "center",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "stockWarehouseName",
                  label: "指定发货仓",
                  align: "center",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "logisticCompanyName",
                  label: "指定物流商",
                  align: "center",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "logisticBusinessName",
                  label: "指定物流业务",
                  align: "center",
                },
              }),
              _c("el-table-column", {
                attrs: { prop: "", label: "操作", align: "center" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c(
                          "el-button",
                          {
                            attrs: { type: "text" },
                            on: {
                              click: function ($event) {
                                return _vm.onEdit(scope.row, scope.$index)
                              },
                            },
                          },
                          [_vm._v("编辑包裹")]
                        ),
                        _c(
                          "el-button",
                          {
                            attrs: { type: "text" },
                            on: {
                              click: function ($event) {
                                return _vm.specifyWarehouse(
                                  scope.row,
                                  scope.$index
                                )
                              },
                            },
                          },
                          [_vm._v("指定发货仓")]
                        ),
                        _c(
                          "el-button",
                          {
                            attrs: { type: "text" },
                            on: {
                              click: function ($event) {
                                return _vm.specifyLogistics(
                                  scope.row,
                                  scope.$index
                                )
                              },
                            },
                          },
                          [_vm._v("指定物流")]
                        ),
                        _c(
                          "el-button",
                          {
                            attrs: { type: "text" },
                            on: {
                              click: function ($event) {
                                return _vm.onDelete(scope.row, scope.$index)
                              },
                            },
                          },
                          [_vm._v("删除包裹")]
                        ),
                      ]
                    },
                  },
                ]),
              }),
            ],
            1
          ),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c("el-button", { on: { click: _vm.handleClose } }, [
                _vm._v(_vm._s(_vm.$t("cancelText"))),
              ]),
              _c(
                "el-button",
                { attrs: { type: "primary" }, on: { click: _vm.confirm } },
                [_vm._v(_vm._s(_vm.$t("okText")))]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c("Parcel", {
        ref: "parcel",
        attrs: { disabled: _vm.disabled },
        on: { confirm: _vm.onParcelConfirm },
      }),
      _c("AppointLogistics", {
        ref: "AppointLogistics",
        on: { confirm: _vm.onLogisticsConfirm },
      }),
      _c("AppointDeliveryWarehouse", {
        ref: "warehouse",
        on: { confirm: _vm.onWarehouseConfirm },
      }),
      _c("PackageView", { ref: "package" }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }